export var MetricsRollupsSubjects;
(function (MetricsRollupsSubjects) {
    MetricsRollupsSubjects["Table"] = "metrics-rollups-table";
    MetricsRollupsSubjects["MetricsRollupsPage"] = "metrics-rollups";
    MetricsRollupsSubjects["TableEmptyState"] = "metrics-rollups-table-empty-state";
    MetricsRollupsSubjects["SearchRollup"] = "search-rollup";
    MetricsRollupsSubjects["NewRollupButton"] = "new-rollup-button";
    MetricsRollupsSubjects["CreateRollup"] = "create-rollup";
    MetricsRollupsSubjects["UpdateRollup"] = "update-rollup";
    MetricsRollupsSubjects["DeleteRollup"] = "delete-rollup";
    MetricsRollupsSubjects["ActivateRollup"] = "activate-rollup";
    MetricsRollupsSubjects["DeactivateRollup"] = "deactivate-rollup";
    MetricsRollupsSubjects["AccountIdSelect"] = "account-id-select";
    MetricsRollupsSubjects["MetricNameSelect"] = "metric-mame-select";
    MetricsRollupsSubjects["ModalCheckbox"] = "modal-checkbox";
    MetricsRollupsSubjects["Modal"] = "metrics-drop-rollup-modal";
    MetricsRollupsSubjects["AddRollupButton"] = "add-rollup-button";
    MetricsRollupsSubjects["MetricFieldNameSelect"] = "metric-field-name-select";
    MetricsRollupsSubjects["MetricFieldValueInput"] = "metric-field-value-input";
    MetricsRollupsSubjects["ActivationToggle"] = "activation-toggle";
    MetricsRollupsSubjects["BulkDeleteRollup"] = "bulk-delete-rollups";
    MetricsRollupsSubjects["BulkCreateRollup"] = "bulk-create-rollups";
})(MetricsRollupsSubjects || (MetricsRollupsSubjects = {}));
export var RollupFunction;
(function (RollupFunction) {
    RollupFunction["COUNT"] = "COUNT";
    RollupFunction["LAST"] = "LAST";
    RollupFunction["MAX"] = "MAX";
    RollupFunction["MEAN"] = "MEAN";
    RollupFunction["MEDIAN"] = "MEDIAN";
    RollupFunction["MIN"] = "MIN";
    RollupFunction["P10"] = "P10";
    RollupFunction["P20"] = "P20";
    RollupFunction["P25"] = "P25";
    RollupFunction["P30"] = "P30";
    RollupFunction["P40"] = "P40";
    RollupFunction["P50"] = "P50";
    RollupFunction["P60"] = "P60";
    RollupFunction["P70"] = "P70";
    RollupFunction["P75"] = "P75";
    RollupFunction["P80"] = "P80";
    RollupFunction["P90"] = "P90";
    RollupFunction["P95"] = "P95";
    RollupFunction["P99"] = "P99";
    RollupFunction["P999"] = "P999";
    RollupFunction["P9999"] = "P9999";
    RollupFunction["STDEV"] = "STDEV";
    RollupFunction["SUM"] = "SUM";
    RollupFunction["SUMSQ"] = "SUMSQ";
})(RollupFunction || (RollupFunction = {}));
//# sourceMappingURL=metrics-rollups.enum.js.map